import React from "react";
import { Seo } from "../components/Seo";
import { SEO } from "../seo";
import { Faq } from "../components/Faq";
import { FAQS } from "../data/content";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqPage() {
  return (
    <div className="pt-10">
      <Seo {...SEO.faq} jsonLd={faqJsonLd} />
      <Faq />
    </div>
  );
}
